import React from 'react';

import {Row, Col, Button, Spin, Icon, Tag} from 'antd';

import './OrderInformationPanel.scss';

import TrackAndTracePanel from 'components/TrackAndTracePanel';

import OrderDetailsPanel from "components/OrderDetailsPanel";
import OrderBeneficiaryDetailsPanel from "components/OrderBeneficiaryDetailsPanel";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import DocumentOriginatorCorporateUploading from "./DocumentOriginatorCorporateUploading";
import Modal from "antd/lib/modal";
import DocumentOrderUploading from "./DocumentOrderUploading";

class OrderInformationPanel extends React.Component {

  state = {
    isUserDocumentOpen:false
  }

  canCancelOrder = (order) => {
    if (order.orderStatus === "PENDING_APPROVAL") {
      return this.props.customer.approval && this.props.customer.roleResources.filter(s => s.name === 'APPROVER').length > 0;
    } else if (order.orderStatus === 'PENDING_AUTHORIZE') {
      return this.props.customer.approval && this.props.customer.roleResources.filter(s => s.name === 'AUTHORIZER').length > 0;
    }
    return order.orderStatus === "BOOKING";

  };

  render() {
    const intl = this.props.useIntl;
    let order = this.props.order;

    return (
      <div className="order-information-panel">
        <div className="bp-small-bordered-panel">
          <span className="reference-number-label"><FormattedMessage id="app.panel.orderinfomationpanel.transactionnumber"/>{' '}{this.props.order.orderId}</span>
        </div>
        <Row className={"manage-order-timeline"} gutter={24}>
          <Col md={12}>
            <h6 className={"fw-600"}><FormattedMessage id="app.panel.orderinfomationpanel.trackandtrace"/></h6>
            <div className="bp-bordered-panel track-and-trace-panel">
              <TrackAndTracePanel order={this.props.order} />
            </div>
          </Col>
          <Col md={12}>
            <div className="second-column-wrapper">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.orderinfomationpanel.orderdetails"/></h6>
              <div className="bp-bordered-panel">
                <OrderDetailsPanel
                    order={this.props.order}
                    orderPaymentSlip = {this.props.orderPaymentSlip}
                    documents={this.props.documents}
                    uploaded={this.props.uploaded}
                    handleRemoveFile={this.props.handleRemoveFile}
                />
              </div>
            </div>
            <div className="second-column-wrapper">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.orderinfomationpanel.beneficiarydetails"/></h6>
              <div className="bp-bordered-panel">
                  {(this.props.order.beneficiary &&
                <OrderBeneficiaryDetailsPanel order={this.props.order} customer={this.props.customer} />)}

              </div>
            </div>
          </Col>
        </Row>

        {this.props.currentUser && !this.props.currentUser.role.readOnly && this.canCancelOrder(this.props.order) && (
          <div className="bp-buttons-panel">
            <Button
              size="large"
              type="danger"
              onClick={() => this.props.onCancelOrder(this.props.order)}
              htmlType={"button"}>
             {this.props.labelCancel ? this.props.labelCancel : intl.formatMessage({id: "app.panel.orderinfomationpanel.cancelorder"})}
            </Button>
          </div>
        )}
      </div>
    )
  }
}


const mapStateToProps = state =>{
  return {
    currentUser: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(OrderInformationPanel)));
// export default withUseIntl(OrderInformationPanel);
